exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".M87yJ{color:red;font-size:10px;font-weight:400;padding-bottom:10px;display:inline-block;padding-right:20px;text-align:left;width:420px}._2c786 .M87yJ{width:100%}._2oCzq{padding-bottom:10px;font-size:16px;font-weight:700;margin:0}._2voSq .HPHKI{padding:0 20px 0 0!important}._2c786 .HPHKI{padding:0}", ""]);

// exports
exports.locals = {
	"root": "_2voSq",
	"rootMobile": "_2c786",
	"warningBlock": "M87yJ",
	"messageTitle": "_2oCzq",
	"dialogForm": "HPHKI"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/shared/components/AdvertMessage/AdvertMessage.css
// module id = 3292
// module chunks = 32